import { PriceApi } from 'infra/modules/PriceModule/PriceModule.api';
import { ApiHelper } from 'utils/ApiHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

export class McsPricingApi {
    sendConfiguration(extra) {
        const data = {
            info: {
                name: '',
                company: '',
                position: '',
                email: BoundCurrentUserSelectors.getEmail(),
                phone: '+71111111111',
                extra,
            },
        };

        return Promise.resolve(
            ApiHelper.rpcCall({
                url: '/api/v1/requests/infra',
                method: 'POST',
                data,
            }),
        );
    }

    loadPrice(pid = BoundCurrentUserSelectors.getPid()) {
        return PriceApi.loadPrice(pid);
    }
}
